export class Hora {
  hour: number;
  minute: number;

  constructor(hora: number, minuto: number) {
    this.hour = hora;
    this.minute = minuto;
  }
}
